import React, { Fragment } from "react";
import { Box, Container, Grid } from "@mui/material";
import ProjectCard from "../../example/home/project/ProjectCard";
import PageHeader from "../../example/pages-header/PageHeader";
import NoData from "../../components/no-data/NoData";
import ErrorPage from "../../components/error/Error";
import useFetchObjects from "../../api/useFetchObjects";
import ProjectSkeleton from "./loading/ProjectSkeleton";
import SEO from "../../components/ceo/CEO";

const Project = () => {
  const { data, isLoading, isError, isSuccess, error, refetch } =
    useFetchObjects(["Projects"], "projects");

  if (isLoading) {
    return <ProjectSkeleton />;
  }

  if (isError) {
    return <ErrorPage errorMessage={error.message} refetch={refetch} />;
  }

  if (isSuccess && (!data || data.length === 0)) {
    return <NoData refetch={refetch} />;
  }

  if (isSuccess) {
    return (
      <Fragment>
        <SEO
          title="Our Projects"
          description="Explore some of our latest projects that showcase our innovative solutions and impactful work."
          url="https://shallafg.org/projects/"
        />
        <PageHeader
          title="Our Projects"
          subtitle="Explore some of our latest projects that showcase our innovative solutions and impactful work."
        />
        <Box
          sx={{
            backgroundImage: "linear-gradient(to right, #0B0F19, #1A2E55)",
            color: "#FFFFFF",
            paddingY: "100px",
            minHeight: "100vh",
          }}
        >
          <Container maxWidth="lg">
            <Grid container spacing={6}>
              {data.map((project) => (
                <Grid item xs={12} sm={6} md={4} key={project.id}>
                  <ProjectCard project={project} />
                </Grid>
              ))}
            </Grid>
          </Container>
        </Box>
      </Fragment>
    );
  }

  return null;
};

export default Project;
